module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-category__wrap"
  }, [_c('div', {
    staticClass: "projects-category__header"
  }, [_c('h1', {
    staticClass: "header header--1 header--no-margin-bottom"
  }, [_vm._v("\n            " + _vm._s(_vm.categoryName) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "projects-category__filter"
  }, [_c('list-filter', {
    attrs: {
      "years": _vm.years,
      "yearsFilter": _vm.yearsFilter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "projects-category__projects",
    class: {
      'projects-category__projects--loading': _vm.loading
    }
  }, [_vm._m(0), _vm._v(" "), _c('list', {
    attrs: {
      "posts": _vm.projectsFormatted
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-category__loader"
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('span', {
    staticClass: "loader__square"
  }), _vm._v(" "), _c('span', {
    staticClass: "loader__square"
  }), _vm._v(" "), _c('span', {
    staticClass: "loader__square"
  }), _vm._v(" "), _c('span', {
    staticClass: "loader__square"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7745d315"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/modules/category.vue
// module id = 356
// module chunks = 0